module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.type === 'campusSubmission') ? _c('h2', [_vm._v("Campus Submission")]) : _c('h2', [_vm._v("Final Project Submission")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.type === 'campusSubmission') ? _c('div', {
    staticClass: "campus-instructions"
  }, [_vm._v("\n            Submit your work made at campus below."), _c('br'), _c('br'), _vm._v("\n\n            For information on reels:"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://portal.tttc.ca/#/kb-article/26"
    }
  }, [_vm._v("https://portal.tttc.ca/#/kb-article/26")]), _c('br'), _c('br'), _vm._v("\n\n            For information on codecs:"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://portal.tttc.ca/#/kb-article/32"
    }
  }, [_vm._v("https://portal.tttc.ca/#/kb-article/32")]), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.type === 'demoReel' && _vm.text) ? _c('div', [(_vm.text.intro) ? _c('div', {
    staticClass: "final-project-intro-text",
    domProps: {
      "innerHTML": _vm._s(_vm.text.intro[0].text)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "dam-fields"
  }, [_c('dropzone', {
    ref: "finalProjectUpload",
    attrs: {
      "id": "finalProjectUpload",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-files-added": function($event) {
        _vm.sendValidationAlert();
        _vm.triggerCoverflow($event)
      }
    }
  }), _vm._v(" "), _c('coverflow', {
    attrs: {
      "images": _vm.assetImages
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.title),
      expression: "submission.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.titlePlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.submission.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.submission.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.gallerySoftware) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Software Used")]), _vm._v(" "), _c('software-select', {
    attrs: {
      "options": _vm.gallerySoftware,
      "canCreate": false,
      "placeholder": "'Select all software used in the making of this project.'"
    },
    model: {
      value: (_vm.submission.softwareUsed),
      callback: function($$v) {
        _vm.submission.softwareUsed = $$v
      },
      expression: "submission.softwareUsed"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('tag-select', {
    attrs: {
      "search": _vm.searchTags,
      "canCreate": true,
      "placeholder": "'Short descriptive keywords describing the imagery, eg: sci-fi, warrior, sword, cat, ninja, castle, bird'"
    },
    model: {
      value: (_vm.submission.tags),
      callback: function($$v) {
        _vm.submission.tags = $$v
      },
      expression: "submission.tags"
    }
  })], 1), _vm._v(" "), (_vm.type === 'campusSubmission' || _vm.type === 'demoReel' && _vm.isCampusStudent) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Industry Focus")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.industryFocus),
      expression: "submission.industryFocus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.submission.industryFocus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.industryFocuses), function(focus) {
    return _c('option', {
      key: focus
    }, [_vm._v(_vm._s(focus))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.type === 'campusSubmission') ? _c('div', {
    staticClass: "form-group final-project"
  }, [_c('div', [_vm._v("Final Project")]), _vm._v(" "), _c('label', [_vm._v("Yes"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.isFinalProject),
      expression: "submission.isFinalProject"
    }],
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.submission.isFinalProject, "Yes")
    },
    on: {
      "__c": function($event) {
        _vm.submission.isFinalProject = "Yes"
      }
    }
  }), _c('span', {
    staticClass: "toggle"
  })]), _vm._v(" "), _c('label', [_vm._v("No"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.isFinalProject),
      expression: "submission.isFinalProject"
    }],
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.submission.isFinalProject, "No")
    },
    on: {
      "__c": function($event) {
        _vm.submission.isFinalProject = "No"
      }
    }
  }), _c('span', {
    staticClass: "toggle"
  })])]) : _vm._e(), _vm._v(" "), (_vm.type === 'campusSubmission') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Creation Date *")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "option": _vm.dateOptions,
      "date": _vm.creationDate
    },
    model: {
      value: (_vm.creationDate),
      callback: function($$v) {
        _vm.creationDate = $$v
      },
      expression: "creationDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Own Personal Artist Nickname / Alias")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.moniker),
      expression: "submission.moniker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "If you have an artist moniker you prefer to be credited with instead of your real name, put it here"
    },
    domProps: {
      "value": (_vm.submission.moniker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.submission.moniker = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Concept Credit *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.conceptCredit),
      expression: "submission.conceptCredit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Please be very sure to provide the correct name and spelling of the concept artist, if applicable"
    },
    domProps: {
      "value": (_vm.submission.conceptCredit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.submission.conceptCredit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group rookies-submission"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.isRookiesSubmission),
      expression: "submission.isRookiesSubmission"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.submission.isRookiesSubmission) ? _vm._i(_vm.submission.isRookiesSubmission, null) > -1 : (_vm.submission.isRookiesSubmission)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.submission.isRookiesSubmission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.submission.isRookiesSubmission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.submission.isRookiesSubmission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.submission.isRookiesSubmission = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Tick this box if this project will be submitted to The Rookies")])]), _vm._v(" "), (_vm.type === 'demoReel') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please tell us what state this project is in:")]), _vm._v(" "), _c('div', {
    staticClass: "project-status"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submissionFinished),
      expression: "submissionFinished"
    }],
    attrs: {
      "type": "radio",
      "name": "submission_finished",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.submissionFinished, "false")
    },
    on: {
      "__c": function($event) {
        _vm.submissionFinished = "false"
      }
    }
  }), _vm._v("\n                            This is a work in progress submission for term end\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "project-status"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submissionFinished),
      expression: "submissionFinished"
    }],
    attrs: {
      "type": "radio",
      "name": "submission_finished",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.submissionFinished, "true")
    },
    on: {
      "__c": function($event) {
        _vm.submissionFinished = "true"
      }
    }
  }), _vm._v("\n                        This is a final project and ready for approval\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.type !== 'campusSubmission') ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.submissionFinished === 'false') ? _c('div', {
    staticClass: "course-description"
  }, [_vm._m(0)]) : _c('label', [_vm._v("Comments & Questions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submission.comments),
      expression: "submission.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.submission.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.submission.comments = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'finalAssignment') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Source File(s) * (max 20 files, please zip folders together)")]), _vm._v(" "), _c('dropzone', {
    ref: "sourceFiles",
    attrs: {
      "id": "sourceFiles",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 100,
      "dropzone-options": _vm.sourceFileOptions
    },
    on: {
      "vdropzone-files-added": [function($event) {}, function($event) {
        _vm.createThumbnails()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "source-files"
  }, _vm._l((_vm.submission.sourceFiles), function(file, $index) {
    return _c('a', {
      key: $index,
      staticClass: "source-file"
    }, [_vm._v("\n                        " + _vm._s(file) + "\n                        "), _c('i', {
      staticClass: "fa fa-remove cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeSourceFile($index)
        }
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.submitting,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitProject()
      }
    }
  }, [_vm._v("Submit")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cms-body"
  }, [_c('label', [_vm._v("If your submission is a WIP, please provide the following info: *\n                        "), _c('ul', [_c('li', [_vm._v("Outstanding tasks")]), _vm._v(" "), _c('li', [_vm._v("Revised expected final delivery date")]), _vm._v(" "), _c('li', [_vm._v("Any additional questions/comments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e2cb800!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/dam-submission/DAMSubmission.vue
// module id = 2045
// module chunks = 2